import { z } from 'zod';

export const whyCariiSchema = z.object({
  eyebrow: z.string().min(1),
  title: z.string().min(1),
  cards: z
    .array(
      z.object({
        mark: z.string().min(1),
        title: z.string().min(1),
        body: z.string().min(1),
      }),
    )
    .length(4),
});

export type WhyCarii = z.infer<typeof whyCariiSchema>;
